import { render, staticRenderFns } from "./dex-point.vue?vue&type=template&id=313f83a7&scoped=true"
import script from "./dex-point.vue?vue&type=script&lang=ts"
export * from "./dex-point.vue?vue&type=script&lang=ts"
import style0 from "./dex-point.vue?vue&type=style&index=0&id=313f83a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f83a7",
  null
  
)

export default component.exports